<div class="terms">
  <div class="terms-block">
    <div class="cls_002">CARTRANSPORTPRO.COM Terms of Use</div>
    <div class="cls_005">
      These Terms of Use govern your use of: (1) the Cartransportpro.com website
      (<A HREF="https://www.cartransportpro.com/" target="_blank">www.cartransportpro.com</A>)) and all of the content,
      tools, applications (including mobile
      applications), and services available through the <A HREF="https://cartransportpro.com"
        target="_blank">cartransportpro.com</A> website
      (collectively, the "<A HREF="https://cartransportpro.com" target="_blank">cartransportpro.com</A> Site"); As used
      herein, (i) "you" or "your" refers to
      you as a user of Cartransportpro.com ", "we", or "us" refers to Cartransportpro.com and
      Yota Shipping Inc, Inc.; and (iii) "Terms of Use" refers to these Terms of Use, together
      with any other notices, policies, disclaimers, or restrictions posted by us on any of the
      Sites (collectively, the "Terms of Use").
      Use of the Sites is restricted to Yota Shipping Inc and its authorized users. Unauthorized
      use of the Sites, including, but not limited to, unauthorized entry into a Site, misuse of
      passwords, or misuse of any information within the Sites, is strictly prohibited. Each time
      you enter a login ID and password on a Site: (1) you represent to us that you have been
      authorized to use that Site by (i) Yota Shipping Inc or (ii) a party that has an agreement
      with Yota Shipping Inc, in accordance with the terms of such agreement; (2) you
      represent to us that you are an employee or agent of a party described in item 1 above;
      (3) you represent to us that you are the user assigned to use the login ID and password
      that is accessing the Site; and (4) you agree to be bound by these Terms of Use.
      Authorized Users of the Cartransportpro.com Site will be referred to herein as
      "Member" or "Members" collectively; the term "Membership" will refer to status as a
      Member of Cartransportpro.com. These Terms of Use are legally binding, with the same
      legal effect as a signed, written agreement entered into with us.
    </div>
    <div class="terms-blocks">
      <div>
        <div class="row">
          <div class="cls_004">1.</div>
          <div class="cls_004 row-header">Introduction to Cartransportpro.com and Car-T Client:</div>
        </div>
        <div class="row-block cls_005">
          The Cartransportpro.com System. Through the Cartransportpro.com Site, we
          offer an Internet-based system (the "Cartransportpro.com System") that allows
          individuals and companies that have vehicles to ship to connect with vehicle
          transportation companies by: (1) allowing Members to post data and information
          regarding vehicles for shipment or vehicle transportation services, references,
          evidence of insurance coverage, copies of government licenses, and other data
          and information that can be reviewed by other Members who may be interested
          in entering into a business relationship, and (2) allowing Members to make their
          own independent evaluations of whether they are interested in entering into
          business relationships with other Members. The Cartransportpro.com System
          may also allow Members to "rate" other Members or to provide information of
          general interest to other Members with regard to, for example, truck stops, repair
          centers, and insurance companies. You understand and acknowledge that we do
          not and cannot control the reliability, completeness, usefulness, safety, or
          accuracy of information available through the Cartransportpro.com Site,
          including, without limitation, through the Cartransportpro.com System, because
          such data and information is provided solely by the Members over whom we
          have no control.
          The Car-T Client System. As an add-on to the Cartransportpro.com System, we
          offer a Mobile Solution (the "Car-T Client App") that offers additional features to
          companies and individuals in the auto transport industry. The Car-T Client
          System allows users to, among other things, to generate quotes, orders,
          payments. In order to become and remain a Car-T Client Member, you must
          download the Car-T Client APP.
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">2.</div>
          <div class="cls_004 row-header">Member Responsibilities.</div>
        </div>
        <div class="row-block cls_005">
          Carriers. If you are a Member and a carrier that enters into a business
          relationship with Cartransportpro.com, you are solely and fully responsible for
          abiding by all applicable industry and professional standards, including, without
          limitation: picking up and delivering vehicles within the agreed-upon windows of
          time and at the agreed-upon price, using only the Car-T Driver App; handling
          damage claims fairly and responsively; promptly forwarding any payments in
          excess of agreed upon carrier payment to cartransportpro.com, when applicable;
          interacting with all parties in a professional and courteous manner; maintaining
          adequate insurance coverage of 250,000 Cargo and applicable licenses at all
          times; complying with all applicable laws, rules, and regulations, including, but
          not limited to, regulations of the Federal Motor Carrier Safety Administration
          (FMCSA).
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">3.</div>
          <div class="cls_005 row-header">
            Member Registration. When you register to become a Member, you agree to (a)
            provide accurate, current, and complete information about yourself as prompted
            by the Cartransportpro.com registration form (including your email address) and
            (b) maintain and update your information (including your email address) to keep it
            accurate, current and complete. You acknowledge that, if any information
            provided by you is untrue, inaccurate, obsolete, or incomplete, we reserve the
            right to suspend or terminate your Membership and/or your access to the Sites.
            If, in accordance with your registration, you are granted the ability to assign
            usernames and passwords to other persons within your organization, you hereby
            agree that you will only provide such usernames and passwords to persons that
            have agreed to be bound to the Terms of Use. As part of the registration process,
            you may be asked to select a username and password. We may refuse to grant
            you a username that impersonates someone else, is or may be illegal, is or may
            be protected by trademark or other proprietary rights law, is vulgar or otherwise
            offensive, or may cause confusion, as determined by us in our sole discretion.
            You agree not to transfer or resell your use of or access to any of the Sites to any
            third party. YOU HEREBY ACKNOWLEDGE AND AGREE THAT IT IS A
            VIOLATION OF THE TERMS OF USE TO LOG ONTO ANY SITE WITH A LOGIN
            ID OR PASSWORD THAT WAS NOT ASSIGNED TO YOU PERSONALLY. YOU
            AGREE TO KEEP YOUR LOGIN ID AND PASSWORD CONFIDENTIAL AND TO
            NOTIFY US IMMEDIATELY IF YOU LEARN THAT THE SECURITY OF YOUR
            LOGIN ID AND/OR PASSWORD HAVE BEEN COMPROMISED AND/OR IF
            YOU SUSPECT THAT ANYONE OTHER THAN YOURSELF HAS ACCESSED
            THE SITE WITH YOUR LOGIN ID AND/OR PASSWORD. YOU ARE ENTIRELY
            RESPONSIBLE FOR ANY AND ALL ACTIVITIES THAT ARE CONDUCTED
            THROUGH YOUR ACCOUNT
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">4.</div>
          <div class="cls_004 row-header">Intellectual Property.</div>
        </div>
        <div class="row-block cls_005">
          <ul>
            <li>Limited License. Subject to these Terms of Use and the timely payment of
              all subscription fees hereunder, we grant you a non-exclusive,
              nontransferable, non-sublicensable, limited right and license, during the
              term of your registration (i) to access and use the Sites as made available
              by us, and (ii) to use data, text, graphics, images and links (collectively,
              the "Materials") displayed on the Sites, in each case solely for the
              purposes of evaluation to determine if you would like to enter into a
              business relationships with Crtransportpro.com and for your own internal
              business use.
            </li>
            <li>
              Restrictions on Use. You hereby acknowledge and agree that you may not
              use the Sites or the Materials for any purpose other than as expressly
              described in the Terms of Use, and you will use the Sites and Materials in
              accordance with all applicable laws, rules, and regulations. You will not,
              and will not permit any third party to: (a) copy all or any portion of the Sites
              or Materials; (b) decompile, disassemble or otherwise reverse engineer
              the Sites, or any portion thereof, or determine or attempt to determine any
              source code, algorithms, methods, or techniques used or embodied in the
              Sites or any portion thereof; (c) modify, translate, or create any derivative
              works based upon the Sites or the Materials; (d) distribute, disclose,
              market, rent, lease, assign, sublicense, pledge, or otherwise transfer the
              Sites or Materials, in whole or in part, to any third party; (e) remove or alter
              any copyright, trademark, or other proprietary notices, legends, symbols,
              or labels appearing on or in the Sites or the Materials; or (f) incorporate
              any of the Sites or Materials or any portion thereof into any other
              compilations, materials, products, or services. In the event of any violation
              of this Section, we may immediately terminate your Membership and/or
              access to the Sites and pursue equitable relief in accordance with these
              Terms of Use and applicable law.
            </li>
            <li>
              Intellectual Property Rights. Unless otherwise indicated, the Site and the
              Marketplace Offerings are our proprietary property and all source code,
              databases, functionality, software, website designs, audio, video, text,
              photographs, and graphics on the Site (collectively, the “Content”) and the
              trademarks, service marks, and logos contained therein (the “Marks”) are
              owned or controlled by us or licensed to us, and are protected by
              copyright and trademark laws and various other intellectual property rights
              and unfair competition laws of the United States, international copyright
              laws, and international conventions. The Content and the Marks are
              provided on the Site “AS IS” for your information and personal use only.
              Except as expressly provided in these Terms of Use, no part of the Site or
              the Marketplace Offerings and no Content or Marks may be copied,
              reproduced, aggregated, republished, uploaded, posted, publicly
              displayed, encoded, translated, transmitted, distributed, sold, licensed, or
              otherwise exploited for any commercial purpose whatsoever, without our
              express prior written permission
            </li>
            <li>Provided that you are eligible to use the Site, you are granted a limited
              license to access and use the Site and to download or print a copy of any
              portion of the Content to which you have properly gained access solely for
              your personal, non-commercial use. We reserve all rights not expressly
              granted to you in and to the Site, the Content and the Marks.
            </li>
            <li>
              Updates and Modifications. We reserve the right to withdraw, suspend, or
              discontinue at any time and from time to time the Terms of Use, any
              Materials available on the Sites and any functionality or features in or on
              the Sites, including the cessation of all activities associated with any Site,
              with or without notice. We may update or modify these Terms of Use from
              time to time by posting an updated or modified version of the Terms of Use
              to the Sites. It is your responsibility to regularly check and monitor the
              Sites for any updates or modifications to the Terms of Use. By continuing
              to use or access the Sites following posting of any updates or
              modifications to the Terms of Use, you agree to be bound by such updates
              or modifications
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">5.</div>
          <div class="cls_005 row-header">Code of Conduct. While using the Sites, you agree:</div>
        </div>
        <div class="row-block cls_005">
          <ul>
            <li>
              Not to use the Sites for any purpose that is improper, unlawful, abusive,
              harassing, libelous, defamatory, obscene, or threatening, or that violates
              the Terms of Use;
            </li>
            <li>
              Not to restrict or inhibit any other visitor or Member from using the Sites,
              including, without limitation, by means of "hacking", denial-of-service
              attack, or defacing any portion of the Sites;
            </li>
            <li>
              Not to express or imply that any statements you make are endorsed by us,
              without our prior written consent;
            </li>
            <li>
              Not to transmit (i) any content or information that is unlawful, fraudulent,
              threatening, abusive, libelous, defamatory, obscene or otherwise
              objectionable, or infringes Yota Shipping Inc’s or any third party's
              intellectual property or other rights; (ii) any material, non-public information
              about companies without their authorization to do so; (iii) any trade secret
              of any third party; or (iv) any advertisements, solicitations, chain letters,
              pyramid schemes, investment opportunities, or other unsolicited
              commercial communication (except as otherwise expressly permitted by
              us);
            </li>
            <li>Not to engage in spamming or flooding;</li>
            <li>Not to transmit any software or other materials that contain any viruses,
              worms, Trojan horses, defects, date bombs, time bombs, or other items of
              a destructive nature;
            </li>
            <li>Not to "frame" or "mirror" any part of the Sites without Yota Shipping Inc’s
              prior written authorization;
            </li>
            <li>
              Not to direct link, inline link, deep link, or otherwise hyperlink any page of
              the Sites other than the home page;
            </li>
            <li>
              Not to use any robot, spider, site search/retrieval application, or other
              manual or automatic device or process to retrieve, index, "data mine", or
              in any way reproduce or circumvent the navigational structure or
              presentation of the Sites or their contents; and
            </li>
            <li>
              Not to harvest or collect information about visitors to the Sites or Members
              without their express consent.
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">6.</div>
          <div class="cls_005 row-header">
            Information and Material Provided by Yota Shipping Inc or via the Sites. Although
            we strive to provide Materials that are both useful and accurate, data and other
            information change frequently. Accordingly, although we endeavor to use
            reasonable care in assembling the Materials, the Materials may not be up-todate, accurate, or complete. In
            addition, much of the Materials are contributed to
            the Sites by industry service providers or Members. The inclusion of such
            information does not indicate our approval or endorsement of such providers or
            Members, and we expressly disclaim any liability with respect to the foregoing. In
            some cases, we may provide access to forms that Members may use for the
            purpose of contracting with one another. We are not a party to any such contract,
            inclusion of access to such contracts does not indicate approval or endorsement
            of such contracts, and we expressly disclaim any liability with respect to the
            foregoing. Members are solely responsible for determining whether, and on what
            terms, to enter into business relationships with other Members.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">7.</div>
          <div class="cls_005 row-header">
            No Rendering of Legal Advice. IN NO WAY DOES ANY DATA, INFORMATION,
            CONTENT, OR MATERIAL PROVIDED THROUGH THE SITES (INCLUDING
            WITHOUT LIMITATION, ANY CONTRACTS, DISCLAIMERS, OR MENUS)
            CONSTITUTE LEGAL ADVICE. WE ARE NOT ENGAGED IN THE PRACTICE
            OF LAW OR IN PROVIDING LEGAL SERVICES. ACCESS TO, TRANSMISSION
            OR RECEIPT OF, OR RELIANCE UPON CONTRACTS, FORMS, OR OTHER
            MATERIALS, DATA, CONTENT, OR INFORMATION FROM THE SITES DOES
            NOT CREATE AND IS NOT INTENDED TO CREATE AN ATTORNEY-CLIENT
            RELATIONSHIP BETWEEN YOU OR ANY OTHER PERSON AND US. AS
            LEGAL ADVICE MUST BE TAILORED TO THE SPECIFIC CIRCUMSTANCES
            OF EACH CASE, AND LAWS ARE CONSTANTLY CHANGING, NOTHING
            PROVIDED HEREIN SHOULD BE USED AS A SUBSTITUTE FOR THE ADVICE
            OF YOUR OWN COMPETENT COUNSEL LICENSED IN THE APPLICABLE
            JURISDICTION WITH REFERENCE TO THE PARTICULAR CIRCUMSTANCES.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">8.</div>
          <div class="cls_005 row-header">
            Disclaimers. THE SITES, THE MATERIALS, AND ANY SOFTWARE,
            PRODUCT, OR SERVICE OBTAINED FROM US ARE PROVIDED "AS IS" AND
            WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO
            THE FULLEST EXTENT PERMISSIBLE UNDER APPLICABLE LAW, Yota
            Shipping Inc AND ITS AFFILIATES, LICENSORS, SUPPLIERS, ADVERTISERS,
            SPONSORS, AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR
            IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OF
            TITLE, NON-INFRINGEMENT, ACCURACY, MERCHANTABILITY, AND
            FITNESS FOR A PARTICULAR PURPOSE, AND ANY WARRANTIES THAT
            MAY ARISE FROM COURSE OF DEALING, COURSE OF PERFORMANCE,
            OR USAGE OF TRADE. APPLICABLE LAW MAY NOT ALLOW THE
            EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSIONS MAY
            NOT APPLY TO YOU. Yota Shipping Inc AND ITS AFFILIATES, LICENSORS,
            SUPPLIERS, ADVERTISERS, SPONSORS, AND AGENTS DISCLAIM ANY
            WARRANTY THAT YOUR USE OF THE SITES, THE MATERIALS, OR ANY
            SOFTWARE, PRODUCT, OR SERVICE WILL BE UNINTERRUPTED, ERRORFREE, OR SECURE, THAT DEFECTS WILL BE CORRECTED,
            OR THAT THE
            SITES, THE SERVER(S) ON WHICH THE SITES ARE HOSTED, OR ANY
            SOFTWARE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
            YOU ACKNOWLEDGE THAT YOU ARE RESPONSIBLE FOR OBTAINING AND
            MAINTAINING ALL TELEPHONE, COMPUTER HARDWARE, AND OTHER
            EQUIPMENT NEEDED TO ACCESS AND USE THE SITES, AND ALL
            CHARGES RELATED THERETO. YOU ASSUME ALL RESPONSIBILITY AND
            RISK FOR YOUR USE OF THE SITES AND THE SOFTWARE AND YOUR
            RELIANCE THEREON. NO OPINION, ADVICE, OR STATEMENT OF Yota
            Shipping Inc OR ITS AFFILIATES, LICENSORS, SUPPLIERS, ADVERTISERS,
            SPONSORS, AGENTS, MEMBERS, OR VISITORS, WHETHER MADE ON THE
            SITES, IN THE SOFTWARE, OR OTHERWISE, WILL CREATE ANY
            WARRANTY. Yota Shipping Inc RESERVES THE RIGHT TO CHANGE ANY
            SOFTWARE OR HARDWARE CONFIGURATIONS (INCLUDING STORAGE
            CAPABILITIES) AT ANY TIME IN ITS SOLE DISCRETION. YOUR USE OF THE
            SITES AND ANY MATERIALS PROVIDED THROUGH THE SITES ARE
            ENTIRELY AT YOUR OWN RISK.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">9.</div>
          <div class="cls_005 row-header">
            Limitation of Liability. UNDER NO CIRCUMSTANCES WILL Yota Shipping Inc,
            ITS AFFILIATES, OR ITS SUBSIDIARIES, OR THEIR RESPECTIVE
            OFFICERS, DIRECTORS, AGENTS, EMPLOYEES, SPONSORS, AND OTHER
            PARTNERS BE RESPONSIBLE OR LIABLE FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, PUNITIVE, OR
            OTHER DAMAGES, WHETHER BASED IN CONTRACT, TORT, OR
            OTHERWISE, ARISING OUT OF OR RELATING IN ANY WAY TO THE SITES,
            THE SERVICES OR MATERIALS AVAILABLE ON THE SITES, INFORMATION
            CONTAINED WITHIN THE SITES, OR RELIANCE ON ANY INFORMATION,
            MATERIALS, OR RESULTS PROVIDED TO OR RECEIVED THROUGH THE
            SITES, EVEN IF Yota Shipping Inc HAS BEEN ADVISED OF THE POSSIBILITY
            OF SUCH DAMAGES. Yota Shipping Inc'S LIABILITY, IF ANY, RESULTING
            FROM YOUR USE OF ANY OF THE SITES IS GOVERNED BY THE
            APPLICABLE AGREEMENT BETWEEN THE PARTY THAT AUTHORIZED YOU
            TO USE THE SITE AND Yota Shipping Inc, IF ANY. ANY LIABILITY THAT Yota
            Shipping Inc MAY HAVE PURSUANT TO SUCH AGREEMENT WOULD BE TO
            THE PARTY THAT AUTHORIZED YOU TO USE THE SITE AND NOT YOU
            PERSONALLY. YOUR SOLE REMEDY FOR DISSATISFACTION WITH THE
            SITE AND/OR SITE-RELATED SERVICES, APPLICATIONS, MATERIALS OR
            INFORMATION IS TO STOP USING THE SITE AND/OR THOSE SERVICES,
            APPLICATIONS, MATERIALS, OR INFORMATION.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">10.</div>
          <div class="cls_005 row-header">
            Indemnification. You agree to indemnify, defend, and hold Yota Shipping Inc and
            its subsidiaries and affiliates, and their respective officers, directors, agents,
            partners, sponsors, employees, and independent contractors harmless from any
            claim or demand, including attorneys' fees, made by any third party due to or
            arising out of: (a) content, data, Materials or information you submit, post to, or
            transmit to or through the Sites; (b) your connection to, access to, or use of the
            Sites and related services, whether authorized or not; (c) your reliance upon any
            Materials provided through the Sites; (d) your use or disclosure of any content,
            data, Materials, or information received through the Sites; (e) your negligence,
            omissions, or misconduct; (f) your violation of any rights of another party; (g) your
            participation in or conducting of any transaction (or failure to conduct or complete
            a transaction) through the Sites; or (h) any communication or representation
            made between you and another Member.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">11.</div>
          <div class="cls_005 row-header">
            Confidentiality. "Confidential Information" means the nonpublic and/or proprietary
            information revealed by Yota Shipping Inc, including, without limitation, all forms
            and types of financial, business, scientific, technical, economic, or engineering
            information of Yota Shipping Inc, and, including, without limitation, the
            applications provided through the Sites. You agree to keep confidential all
            Confidential Information acquired from Yota Shipping Inc, whether in connection
            with your use of the Sites or otherwise, by exercising the same degree of care
            you exercise with your confidential information but in no instance less than a
            commercially reasonable degree of care. You may not use the Confidential
            Information except as expressly provided herein, and you may not disclose the
            Confidential Information without prior express written permission from Yota
            Shipping Inc. All Confidential Information will remain the property of Yota
            Shipping Inc and will not in any manner be deemed licensed or transferred to
            you. You shall return or destroy all Confidential Information on Yota Shipping Inc's
            request, upon the termination of the Terms of Use, upon termination of your
            rights to use the Sites, or upon termination of the access agreement under which
            you are authorized to use the Sites. You must comply with all privacy and data
            protection laws, rules, and regulations which are or which may in the future be
            applicable to your use of the Sites or any applications, data, or information
            provided on or through the Sites. Without limiting the generality of the foregoing
            sentence, you agree that you will not use or disclose to any other party any
            nonpublic personal information which you receive in connection with your
            Membership or through the Sites, except as expressly permitted in these Terms
            of Use or by applicable law. You acknowledge and agree that: (a) irreparable
            injury will result to Yota Shipping Inc in the event of a breach by you of this
            obligation of confidentiality, (b) Yota Shipping Inc’s remedy at law for such breach
            is inadequate, (c) Yota Shipping Inc, in addition to any money damages for any
            such breach, will be entitled to temporary and permanent injunctive relief without
            the necessity of proving damages, and (d) that Yota Shipping Inc will not be
            required to post bond as a condition of such relief. This provision shall survive
            the expiration or termination of the Terms of Use and the applicable access
            agreement or other agreement between Yota Shipping Inc and the party that
            authorized you to use the Site.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">12.</div>
          <div class="cls_005 row-header">
            Use of Member Name. You grant us the right, at our option and expense, to use
            the name of the entity you represent (if any), including reproduction of such
            entity's trademark, trade name, service mark, and logo, for advertisements and
            on other Yota Shipping Inc marketing materials.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">13.</div>
          <div class="cls_005 row-header">
            Copyright. The Digital Millennium Copyright Act of 1998 (the "DMCA") provides
            recourse for copyright owners who believe that material appearing on the Internet
            infringes their rights under U.S. copyright law. If you believe in good faith that
            materials hosted by Yota Shipping Inc infringe your copyright, you (or your agent)
            may send us a notice requesting that the material be removed, or access to it
            blocked. The notice must include the following information: (a) a physical or
            electronic signature of a person authorized to act on behalf of the owner of an
            exclusive right that is allegedly infringed; (b) identification of the copyrighted work
            claimed to have been infringed (or if multiple copyrighted works located on the
            Site are covered by a single notification, a representative list of such works); (c)
            identification of the material that is claimed to be infringing or the subject of
            infringing activity, and information reasonably sufficient to allow us to locate the
            material on the Sites; (d) information reasonably sufficient to permit us to contact
            the complaining party, such as an address, telephone number and email address
            (if available); (e) a statement that the complaining party has a good faith belief
            that use of the material in the manner complained of is not authorized by the
            copyright owner, its agent or the law; and (f) a statement that the information in
            the notification is accurate and, under penalty of perjury, that the complaining
            party is authorized to act on behalf of the owner of an exclusive right that is
            allegedly infringed. Notices and counter-notices with respect to the Sites should
            be sent to Yota Shipping Inc, Inc., ATTN: Serghei Lungu,10450 Turkey Lake Rd
            Orlando FL 32819. We suggest that you consult your legal advisor before filing a
            notice or counter-notice.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">14.</div>
          <div class="cls_004 row-header">Arbitration and Class Waiver.</div>
        </div>
        <div class="row-block cls_005">
          <ul>
            <li>Arbitration. You agree to arbitrate any dispute or claim that you may have
              with us, or any of our affiliates, that arises out of or relates in any way to
              the Sites, the Cartransportpro.com System, or the Car-T Client System.
              Such arbitration will be final and binding. If we elect in our discretion to
              submit to arbitration any dispute or claim that we may have against you,
              any such arbitration will be governed by the provisions of this Section.
            </li>
            <li>
              Class Waiver. Any arbitration proceeding under this Section will take place
              on an individual basis. Class arbitrations and class or representative
              proceedings of any kind are not permitted and you expressly waive your
              ability to participate in a class or representative proceeding against us or
              any of our affiliates. If the arbitration clause is found inapplicable to your
              dispute with us, this class waiver will continue to apply in litigation. You
              agree that this class waiver is an essential element of the agreement
              between you and us and that this class waiver may not be severed. In the
              event that this class waiver is deemed invalid or unenforceable, then the
              entire agreement to arbitrate in this Section will be null and void.
            </li>
            <li>
              Arbitrator Authority. Any dispute or claim subject to arbitration pursuant to
              this Section 23 must be submitted to binding arbitration before a single
              arbitrator administered by JAMS pursuant to JAMS Streamlined Rules.
              The arbitrator will be bound by and will strictly enforce these Terms of Use
              and any additional terms, agreements or attachments between you and us
              and may not limit, expand or otherwise modify any of the provisions of the
              foregoing. Any arbitration will be held in Atlanta, Georgia, unless otherwise
              agreed upon by the parties in writing. Each party will bear its own
              expenses in the arbitration and will share equally the costs of the
              arbitration; provided, however, that the arbitrator will award the applicable
              party any costs and fees to which it may be entitled under Section 18 in
              connection with any indemnification claim. You agree that your
              transactions with us evidence transactions in interstate commerce and
              that the Federal Arbitration Act therefore governs the interpretation and
              enforcement of this Section (notwithstanding the application of Georgia
              law to any underlying claims). You also agree that this Section shall
              survive the expiration or termination of these Terms of Use.
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">15.</div>
          <div class="cls_005 row-header">
            Jurisdictional Issues. The Sites are solely directed to individuals residing in the
            United States. We make no representation that Materials available on or through
            the Sites are appropriate or available for use in locations outside of the United
            States. Those who choose to access the Sites from other locations do so on their
            own initiative and at their own risk, and are responsible for compliance with local
            laws, if and to the extent local laws are applicable.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">16.</div>
          <div class="cls_005 row-header">
            Governing Law. Any dispute arising from or related to the Sites, the
            Cartransportpro.com System, or the Car-T Client System, will be governed and
            construed in accordance with the laws of the State of Georgia, without regard to
            its conflict of laws principles. Any action to enforce any arbitration proceeding,
            and any other legal action, suit or proceeding that is not otherwise subject to
            mandatory arbitration pursuant to Section 23 and arises under or relates to the
            Sites, the Cartransportpro.com System, or the Car-T Client System, will be filed
            exclusively in a state or federal court located in Orange County, Florida; you
            consent to such forum and waive any objection to the laying of venue in such
            forum.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">17.</div>
          <div class="cls_005 row-header">
            <span class="cls_004">Miscellaneous.</span> These Terms of Use and any policies or operating rules posted
            by us on the Site or in respect to the Marketplace Offerings constitute the entire
            agreement and understanding between you and us. Our failure to exercise or
            enforce any right or provision of these Terms of Use shall not operate as a waiver
            of such right or provision. These Terms of Use operate to the fullest extent
            permissible by law. We may assign any or all of our rights and obligations to
            others at any time. We shall not be responsible or liable for any loss, damage,
            delay, or failure to act caused by any cause beyond our reasonable control. If any
            provision or part of a provision of these Terms of Use is determined to be
            unlawful, void, or unenforceable, that provision or part of the provision is deemed
            severable from these Terms of Use and does not affect the validity and
            enforceability of any remaining provisions. There is no joint venture, partnership,
            employment or agency relationship created between you and us as a result of
            these Terms of Use or use of the Marketplace Offerings. You agree that these
            Terms of Use will not be construed against us by virtue of having drafted them.
            You hereby waive any and all defenses you may have based on the electronic
            form of these Terms of Use and the lack of signing by the parties hereto to
            execute these Terms of Use.
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="cls_004">18.</div>
          <div class="cls_005 row-header">
            <span class="cls_004">CONTACT US.</span> In order to resolve a complaint regarding the Site or the
            Marketplace Offerings or to receive further information regarding use of the Site
            or the Marketplace Offerings, please contact us at:
            <div class="cls_003 row-margin">Cartransport Pro Inc</div>
            <div class="cls_006">10450 Turkey Lake Rd</div>
            <div class="cls_006">Orlando, FL 32819</div>
            <div class="cls_006">Phone: 19013087493</div>
            <div class="cls_006">info&#64;cartransportpro.com</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>